import React, { useImperativeHandle, useRef, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Grid,
  Typography,
  Backdrop,
  CircularProgress,
  Alert,
} from "@mui/material";

import {
  ButtonComponent,
  PopupComponent,
  RadioButtonComponent,
} from "../../atoms";
import _ from "lodash";
import { AlertConfirmation, EditAddress } from "../../organisms";

export default ({
  showRadio = true,
  item,
  showBackBtn = true,
  onGetAddressList = () => {},
  onRemoveAddress = () => {},
  isEditable = true
}) => {
  const [editAddress, setEditAddress] = useState(false);
  const addressRef = useRef();
  const [confirmView, setConfirmView] = useState(false);

  const onPress = () => {
    addressRef.current.onPress();
  };

  // useImperativeHandle(ref, () => ({
  //   onPress() {
  //     onAddAddressUpdate();
  //   },
  // }));

  const onUpdate = () => {
    setEditAddress(false);
    onGetAddressList();
  };

  const onRemove = async () => {
    setConfirmView(false);
    onRemoveAddress(item?.id);
  };

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Card sx={{ borderRadius: 3, minWidth:240 }} variant="outlined">
          <CardContent sx={{ height: 270,position: "relative"  }} >
          <Box
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              backgroundColor: _.get(item, "myus_screening_status") === "Approved" ? "green" : "#f26b5e",
              color: "white",
              borderRadius: "12px",
              padding: "2px 8px",
              fontSize: "11px",
              fontWeight: "500",
              textAlign: "center",
            }}
          >
            {_.get(item, "myus_screening_status") === "Approved"
              ? "Approved"
              : _.get(item, "myus_screening_status") === null
              ? "Approval Pending"
              : _.get(item, "myus_screening_status")}
          </Box>
            <Grid container justifyContent={"space-between"}>
              <Grid item>
                <Typography gutterBottom variant="h5" component="div" sx={{marginTop:'8px'}}>
                  {_.get(item, "lable", "")}
                </Typography>
              </Grid>
              {/* {showRadio ? (
                <Grid item>
                  <RadioButtonComponent />
                </Grid>
              ) : null} */}
            </Grid>
            <Grid container justifyContent={"space-between"}>
           
            {/* <Grid item xs={8}> */}
            <Typography
              variant="h6"
              fontFamily={"Source Sans Pro"}
              color="text.secondary"
            >
               {`${_.get(item, "first_name", "")} ${_.get(
                item,
                "last_name",
                ""
              )} `}
            </Typography>
            {/* </Grid> */}
            {/* <Grid item  xs="4" sx={{ flexShrink: 1 }}> */}
         
          {/* </Grid> */}
          <Grid container justifyContent={"space-between"}>
            <Typography
              variant="body2"
              fontFamily={"Source Sans Pro"}
              color="text.secondary"
            >
             
              <Typography
                sx={{
                  display: "-webkit-box",
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  WebkitLineClamp: 2, // Limit to 2 lines
                  maxHeight: "3em", // Adjust the height to fit 2 lines (assuming 1.5em per line)
                }}
                title={_.get(item, "address_line_one", "")}
                variant="body2"
                fontFamily={"Source Sans Pro"}
                color="text.secondary"
              >
                {`${_.get(item, "address_line_one", "")}`}
              </Typography>

              <Typography
                sx={{
                  display: "-webkit-box",
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  WebkitLineClamp: 2, // Limit to 2 lines
                  maxHeight: "3em", // Adjust the height to fit 2 lines (assuming 1.5em per line)
                }}
                title={_.get(item, "address_line_two", "")}
                variant="body2"
                fontFamily={"Source Sans Pro"}
                color="text.secondary"
              >
                {_.get(item, "address_line_two", "") != null ? ` ${_.get(item, "address_line_two", "")}`:''}
              </Typography>
              {`${_.get(item, "city.name", "")} ,  `}
              <br></br>
              {`${_.get(item, "district.name", "")} , `}
              <br></br>
              {`${_.get(item, "province.name", "")} ,  `}
              <br></br>
              {`${_.get(item, "zip_code", "")} `}
              <br></br>
              {`${_.get(item, "mobile", "")} `}
              <br></br>
            </Typography>
                </Grid>
            </Grid>
          </CardContent>
          <CardActions>
            <Grid container justifyContent={"space-between"} spacing={1}>
              {!isEditable ? (<>
              </>):(<>
              <Grid item xs={showBackBtn ? 6 : 12}>
                <ButtonComponent
                  name={"Edit"}
                  variant="contained"
                  width={"100%"}
                  onClick={() => setEditAddress(true)}
                  disabled={!isEditable}
                />
              </Grid>
              </>)}
              
              {showBackBtn ? (
                <Grid item xs={showBackBtn ? 6 : 12}>
                  <ButtonComponent
                    onClick={() => {
                      setConfirmView(true);
                    }}
                    width={"100%"}
                    name={"Delete"}
                  />
                </Grid>
              ) : null}
            </Grid>
          </CardActions>
        </Card>
      </Box>
      <PopupComponent
        maxWidth={"md"}
        actionButtonName={"Edit Address"}
        content={
          <EditAddress item={item} ref={addressRef} onPassResponse={onUpdate} />
        }
        secondaryBtnName={"Cancel"}
        open={editAddress}
        title={"Edit Address"}
        handleClose={() => setEditAddress(false)}
        handleAction={() => onPress()}
      />

      <PopupComponent
        maxWidth={"xs"}
        actionButtonName={"Yes"}
        content={
          <AlertConfirmation
            message={`Are you sure, you want to remove ${item?.lable} address?`}
          />
        }
        secondaryBtnName={"No"}
        open={confirmView}
        title={"Remove a Address"}
        handleClose={() => setConfirmView(false)}
        handleAction={onRemove}
      />
    </>
  );
};
